import { AdCopyEvalDemo } from "@/components/adcopy-eval-demo";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/adcopy-eval-demo")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AdCopyEvalDemo />;
}
